import Task from "../../../lib/html5-software-library/src/ranj/util/executor/Task";
import { getURLParameter } from "../../../lib/html5-software-library/src/ranj/util/URLUtil";

export default class CrashOnPurposeTask extends Task {
    execute(callback, progressCallback) {
        this._crashOnPurpose(callback);
    }

    _crashOnPurpose(callback) {
        if (getURLParameter('crashOnPurpose') == '1') {
            console.warn(`Throwing an error on purpose...`);
            this.throwErrorOnPurposeToTestAppSignalIntegration();
        }

        callback(this);
    }
}